module.exports = __webpack_public_path__ + "media/images/emblems/Faellanden-blazon-b9a3177a1ddcc8b3f713f3e71e20636d.svg";